import axiosClient from "../axiosClient";
import axiosClient_v2 from "../axiosClient_v2";


export const notification = {
    get: (params) => {
        return axiosClient.get('/notification/get-list-notification-popup/', {
            params: params
        })
    },
    get_v2: (params) => {
        return axiosClient_v2.get('/notification/get-list-notification-popup/', {
            params: params
        })
    }
}